import { MapControls } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import { useCallback, useEffect, useRef } from "react";
import { Vector3Tuple } from "three";

const MAP_MODEL_X_OFFSET = 13.9669885868;
const MAP_MODEL_Z_OFFSET = -5.2153374234;

export function CustomMapControls({ target }: { target: Vector3Tuple | null }) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const mapControls = useRef<any>(null);
  const { camera, invalidate } = useThree();

  const focusToActiveCamera = useCallback(
    ([x, , z]: Vector3Tuple) => {
      if (!mapControls.current) return;

      const newX = x - MAP_MODEL_X_OFFSET;
      const newZ = z - MAP_MODEL_Z_OFFSET;

      camera.zoom = 150;
      camera.position.x = newX;
      camera.position.z = newZ;

      const newTarget = mapControls.current.target.clone();

      camera.updateProjectionMatrix();
      newTarget.setX(newX);
      newTarget.setZ(newZ);

      mapControls.current.target.fromArray(newTarget.toArray());
      mapControls.current?.update();
      invalidate();
    },
    [camera, invalidate]
  );

  useEffect(() => {
    if (!target) return;
    focusToActiveCamera(target);
  }, [target, focusToActiveCamera]);

  return (
    <MapControls
      ref={mapControls}
      enableRotate={false}
      zoomToCursor={true}
      maxZoom={200}
      minZoom={50}
      screenSpacePanning={true}
    />
  );
}
